import React from 'react'
import { useSelector } from 'react-redux'
import styled from '@emotion/styled'
import { getFullName, getCustomer, getAssignedTo, getRepliedBy } from '../../shared/utils/helper'
import ChatAvatar from 'components/shared/ChatAvatar'
import ProfileName from './ProfileName'
import ProfileField from './ProfileField'
import { getSelectedInteraction, getProfile, getTags } from 'state/selectors'
import EmptyDivider from '../shared/EmptyDivider'

const ProfileBarContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 19.5625%;
  height: 100%;
`

const ProfileBar = () => {
   const selected = useSelector(getSelectedInteraction)
   const person = getCustomer(selected)
   const profile = useSelector(getProfile)
   const tags = getTags(selected)?.map(t => t.tagName)

   return (
      <ProfileBarContainer>
         {selected &&
         <React.Fragment>
            <ChatAvatar actor={person}/>
            <ProfileName>{profile?.fullName}</ProfileName>
            <ProfileField name="First name:" value={person?.profile?.firstName || '-'}/>
            <ProfileField name="Last name:" value={person?.profile?.lastName || '-'}/>
            <ProfileField name="First message:" value={profile?.firstActivity}/>
            <ProfileField name="Last active on:" value={profile?.lastActivity}/>
            <ProfileField name="Email:" value={profile?.email}/>
            <ProfileField name="Phone number:" value={profile?.phoneNumber}/>
            <ProfileField name="Gender:" value={profile?.gender}/>
            <ProfileField name="Locale:" value={profile?.locale}/>
            <ProfileField name="Timezone:" value={profile?.timezone}/>
            <EmptyDivider size={8}/>
            <ProfileField name="Assigned to:" value={getAssignedTo(selected)}/>
            <ProfileField name="Replied by:" value={getRepliedBy(selected)}/>
            <EmptyDivider size={8}/>
            {tags?.map((t, i) => {
               if (i) {
                  return <ProfileField value={t} key={i}/>
               }
               return <ProfileField name="Tags:" value={t} key={i}/>
            })}
         </React.Fragment>
         }
      </ProfileBarContainer>
   )
}

export default ProfileBar
